var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgDragAudiov2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162px",
    height: "154px",
    viewBox: "0 0 162 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Images/ImgDragAudio v2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 44.8,
    height: 67.2,
    rx: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 35.84,
    height: 53.76,
    rx: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 56,
    height: 84,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Images/ImgDragAudio-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(122.000000, 73.000000) rotate(15.000000) translate(-122.000000, -73.000000) translate(93.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#002048",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 0.75,
    width: 56.1,
    height: 78.5,
    rx: 6.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(6.400000, 6.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B8BFE4",
    mask: "url(#mask-2)",
    transform: "translate(7.863635, 106.260646) rotate(-25.000000) translate(-7.863635, -106.260646) ",
    cx: 7.86363486,
    cy: 106.260646,
    rx: 83,
    ry: 61
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.045266,16.6048843 C21.3969427,16.6048843 16.001202,22.0026896 16.001202,28.6535568 L16.001202,34.7582175 L16.001202,34.7582175 C16.0333195,37.6820287 18.4421323,40.0596335 21.3648251,40.0596335 L22.0714102,40.0596335 C22.6816428,40.0596335 23.1955229,39.5455568 23.1955229,38.9350907 L23.1955229,30.4206954 C23.1955229,29.8102294 22.6816428,29.2961527 22.0714102,29.2961527 L21.3648251,29.2961527 C20.208595,29.2961527 19.1165999,29.6817102 18.2173098,30.3243061 L18.2173098,28.6535568 C18.2173098,23.2557515 22.6174078,18.8539698 28.0131484,18.8539698 C33.4088891,18.8539698 37.8411046,23.2557515 37.8411046,28.6535568 L37.8411046,30.3243061 C36.9418145,29.6817102 35.8819369,29.2961527 34.6935892,29.2961527 L33.9870042,29.2961527 C33.3767716,29.2961527 32.8628915,29.8102294 32.8628915,30.4206954 L32.8628915,38.9350907 C32.8628915,39.5455568 33.3767716,40.0596335 33.9870042,40.0596335 L34.6935892,40.0596335 C37.6483996,40.0596335 40.0250949,37.6820287 40.057355,34.7582175 L40.057355,34.7582175 L40.057355,28.6535568 C40.0893299,22.0026896 34.6935892,16.6048843 28.045266,16.6048843 Z",
    id: "Path",
    fill: "#B8BFE4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(35.500000, 91.000000) rotate(-25.000000) translate(-35.500000, -91.000000) translate(12.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#002048",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 0.75,
    width: 44.58,
    height: 62.5,
    rx: 5.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(5.120000, 5.120000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B8BFE4",
    mask: "url(#mask-4)",
    transform: "translate(45.413461, 93.321631) rotate(15.000000) translate(-45.413461, -93.321631) ",
    cx: 45.413461,
    cy: 93.3216307,
    rx: 83,
    ry: 61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8415532,7.51631047 C15.590583,7.51631047 11.328926,11.8889132 11.328926,17.2765844 L11.328926,22.2217899 L11.328926,22.2217899 C11.3542931,24.5902831 13.2568185,26.5163105 15.565216,26.5163105 L16.1232901,26.5163105 C16.6052633,26.5163105 17.0111353,26.0998721 17.0111353,25.6053516 L17.0111353,18.7080913 C17.0111353,18.2135707 16.6052633,17.7971324 16.1232901,17.7971324 L15.565216,17.7971324 C14.6520038,17.7971324 13.7895256,18.1094612 13.0792494,18.6300091 L13.0792494,17.2765844 C13.0792494,12.9039817 16.5545292,9.33822828 20.8161862,9.33822828 C25.0778432,9.33822828 28.57849,12.9039817 28.57849,17.2765844 L28.57849,18.6300091 C27.8682138,18.1094612 27.0311026,17.7971324 26.0925234,17.7971324 L25.5344493,17.7971324 C25.0524762,17.7971324 24.6466041,18.2135707 24.6466041,18.7080913 L24.6466041,25.6053516 C24.6466041,26.0998721 25.0524762,26.5163105 25.5344493,26.5163105 L26.0925234,26.5163105 C28.426288,26.5163105 30.3034464,24.5902831 30.328926,22.2217899 L30.328926,22.2217899 L30.328926,17.2765844 C30.3541804,11.8889132 26.0925234,7.51631047 20.8415532,7.51631047 Z",
    id: "Path",
    fill: "#B8BFE4",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(74.000000, 56.000000) rotate(-10.000000) translate(-74.000000, -56.000000) translate(38.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#002048",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 0.75,
    width: 70.5,
    height: 98.5,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6A61",
    opacity: 0.529715402,
    mask: "url(#mask-6)",
    cx: 27.8259103,
    cy: 126.710064,
    rx: 83,
    ry: 61
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Headphones_1219649",
    transform: "translate(73.000000, 49.500000) rotate(-10.000000) translate(-73.000000, -49.500000) translate(53.000000, 30.000000)",
    fill: "#FF6A61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8705207,0 C8.90199327,0 0,8.90539956 0,19.878124 L0,29.9497069 L0,29.9497069 C0.0529880552,34.773465 4.02709219,38.6960814 8.84900521,38.6960814 L10.0147424,38.6960814 C11.0215155,38.6960814 11.8693244,37.8479481 11.8693244,36.8407899 L11.8693244,22.7935822 C11.8693244,21.7864239 11.0215155,20.9382906 10.0147424,20.9382906 L8.84900521,20.9382906 C6.94143523,20.9382906 5.13984135,21.5743906 3.65617581,22.6345572 L3.65617581,19.878124 C3.65617581,10.9727245 10.9155394,3.71058315 19.8175326,3.71058315 C28.7195259,3.71058315 36.0318775,10.9727245 36.0318775,19.878124 L36.0318775,22.6345572 C34.548212,21.5743906 32.7996061,20.9382906 30.8390481,20.9382906 L29.6733109,20.9382906 C28.6665378,20.9382906 27.818729,21.7864239 27.818729,22.7935822 L27.818729,36.8407899 C27.818729,37.8479481 28.6665378,38.6960814 29.6733109,38.6960814 L30.8390481,38.6960814 C35.7139492,38.6960814 39.6350653,34.773465 39.6882886,29.9497069 L39.6882886,29.9497069 L39.6882886,19.878124 C39.7410414,8.90539956 30.8390481,0 19.8705207,0 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5E8FA",
    cx: 81,
    cy: 149,
    rx: 50,
    ry: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDragAudiov2);
export default __webpack_public_path__ + "static/media/ImgDragAudiov2.54e2c7eb8c5e5ef1e4121e159f3e7ef7.svg";
export { ForwardRef as ReactComponent };